import React, { FC, FormEvent } from 'react';

import landingVideo from 'assets/videos/landing_vidio_14.mp4';
import { useAnalytics } from 'contexts/AnalyticsContext';
import { ANALYTICS_EVENTS } from 'constants/analyticsEvents';

import {
  StyledContent,
  StyledForm,
  StyledFormField,
  StyledFormInput,
  StyledFormLabel,
  StyledFormSection,
  StyledHeadingContainer,
  StyledSignupHeading,
  StyledSignupSubheading,
  StyledSubmit,
} from './styled';
import { useSubscribeForm } from './hooks';

const SubscribeForm: FC = () => {
  const { track } = useAnalytics();

  const { name, setName, email, setEmail, handleSubmit } = useSubscribeForm();

  const handleJoinWaitList = (e: FormEvent<HTMLFormElement>) => {
    track(ANALYTICS_EVENTS.LandingJonWaitList);
    handleSubmit(e);
  };

  return (
    <StyledFormSection id="landing-form">
      <StyledContent>
        <StyledHeadingContainer>
          <StyledSignupHeading>Let humans be your guide.</StyledSignupHeading>
          <StyledSignupSubheading>Sign up for a better way to do social today.</StyledSignupSubheading>
        </StyledHeadingContainer>
        <StyledForm onSubmit={handleJoinWaitList}>
          <StyledFormField>
            <StyledFormLabel htmlFor="mce-EMAIL">Email Address:</StyledFormLabel>
            <StyledFormInput
              value={email}
              id="mce-EMAIL"
              name="EMAIL"
              type="email"
              required
              onChange={(e) => {
                track(ANALYTICS_EVENTS.LandingWaitListForm);
                setEmail(e.currentTarget.value);
              }}
            />
          </StyledFormField>
          <StyledFormField>
            <StyledFormLabel htmlFor="mce-FNAME">Name:</StyledFormLabel>
            <StyledFormInput
              id="mce-FNAME"
              type="text"
              name="FNAME"
              value={name}
              onChange={(e) => {
                track(ANALYTICS_EVENTS.LandingWaitListForm);
                setName(e.currentTarget.value);
              }}
            />
          </StyledFormField>
          <StyledSubmit type="submit">Join Now</StyledSubmit>
        </StyledForm>
      </StyledContent>
      <video width="128%" height="100%" autoPlay muted playsInline loop preload="auto">
        <source src={`${landingVideo}#t=0.001`} type="video/mp4" />
      </video>
    </StyledFormSection>
  );
};

export default SubscribeForm;
